import React from "react";
import { generateCRUDRoutes } from "../../../utils/index";

import { FaUsers } from "react-icons/fa6";
import Employees from "./index";
import ViewEmployee from "./view";
import EditEmployee from "./edit";

import employeeSalaryRoutes from "./salaries/routes";
import employeeScheduleRoutes from "./schedules/routes"
import employeeSettingRoutes from "./settings/routes";
import { MODULE_EMPLOYEES } from "variables/constants";
import assignedAssetRoutes from "./assigned-assets/routes";
import employeeDocumentRoutes from "./documents/routes";

const employeeRoutes = [	
	generateCRUDRoutes({
		mainTitle: "Employees",
		basePath: "employees",
		mainComponent: <Employees />,
	    layout: "/console",	   
	    icon: <FaUsers className="icon-item" />,
	    subTitle:"Employee",
		detailTitle: "Profile",
	    viewComponent: <ViewEmployee />,
	    createComponent: <EditEmployee />,
	    editComponent: <EditEmployee />,
		level:4,
		moduleId: MODULE_EMPLOYEES,
		viewSubmodules: [
			...employeeSalaryRoutes,
			...employeeScheduleRoutes,
			...employeeSettingRoutes,
			...assignedAssetRoutes,
			...employeeDocumentRoutes,
		]
	})
]

export default employeeRoutes;